import { ListItemText, ListItem, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SideMenuLoading = () => {
  const { t } = useTranslation(['common']);
  return (
    <ListItem aria-live='polite' aria-busy='true' sx={{ flexDirection: 'column', gap: '1rem', mt: '1rem' }}>
      <CircularProgress />
      <ListItemText primary={t('statusMessages.loading')} />
    </ListItem>
  );
};
